// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2LHiQ","detailsBorder":"styles_detailsBorder__2i09A"};